import { render, staticRenderFns } from "./OrganizationSettingsComponent.vue?vue&type=template&id=e6e5a800&scoped=true"
import script from "./OrganizationSettingsComponent.vue?vue&type=script&lang=js"
export * from "./OrganizationSettingsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e5a800",
  null
  
)

export default component.exports